import React, { useState } from 'react';
import { Table } from 'reactstrap';
import { stateConvert } from "utils/stateAbbreviation";
import { TableContainer } from "styles/components/DasboardTable";
import { FORMAT } from 'utils/dateOfBirthValidation';
import * as moment from 'moment';
import { getStateAbbr, getLoggedInUserCountry } from 'helpers';
import MixPalletDetailsModal from 'components/MixPalletDetailsModal';

const ReactTable = (props) => {
  const locale = props?.locale || ((key) => key);
  const userCountry = getLoggedInUserCountry?.() || "USA";

  const [mixModalOpen, setMixModalOpen] = useState(false);
  const [selectedMixOrder, setSelectedMixOrder] = useState(null);

  const isMixPallet = (item) => {
    return !!item?.mixPalletDetails;
  };

  const handleViewMixPallet = (data) => {
    setSelectedMixOrder(data);
    setMixModalOpen(true);
  };

  const status = (status) => {
    if (status === "PENDING") {
      return <button className="status Pending">{status}</button>
    } else if (status === "ASSIGNED") {
      return <button className="status Assigned">{status}</button>
    } else if (status === "SHIPPED") {
      return <button className="status Shipped">{status}</button>
    } else if (status === "DELIVERED") {
      return <button className="status Delivered">{status}</button>
    } else if (status === "COMPLETED") {
      return <button className="status Completed">{status}</button>
    } else if (status === "REQUESTED") {
      return <button className="status Pending">Pending</button>
    } else {
      return <button className="status">{status}</button>
    }
  }

  const orderType = (items) => {
    if (isMixPallet(items)) return 'Mix Pallet';

    if (!items?.loadDetails || items?.loadDetails === null) return 'Pickup'

    let material = items?.loadDetails?.material
    let condition
    if (items?.loadDetails?.condition?.length !== 1) {
      condition = items?.loadDetails?.condition?.join(", ")
    } else {
      if (items?.palletDetails?.condition.length !== 0)
        condition = items?.loadDetails?.condition
    }

    let palletType;
    let moisture = "";
    let size = "";
    let grade = "";
    let LWH
    if (items?.loadDetails?.material !== "WOOD") {
      const length = items?.loadDetails?.length
      const width = items?.loadDetails?.width
      const height = items?.loadDetails?.height
      LWH = length + "x" + width + "x" + height

      // return material + ", " + LWH

      if (condition) {
        condition = condition?.toString()
        condition = condition?.toLowerCase();
        condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
        return LWH + "-" + condition
      } else {
        return LWH
      }
    } else {
      palletType = items?.loadDetails?.palletType
      // if(palletType === "STRINGER"){
      //   palletType = items?.loadDetails?.size
      // }

      //if (items?.loadDetails?.moisture)
      // moisture = ", " + items?.loadDetails?.moisture

      if (items?.loadDetails?.size)
        size = items?.loadDetails?.size

      if (items?.loadDetails?.grade)
        grade = ", " + items?.loadDetails?.grade

      // return material + ", " + condition + ", " + palletType + "" + moisture + "" + size + "" + grade
      // return size + "" + grade+ ", " + material + ", " + palletType + "-" + condition 
      if (size || grade) {
        palletType = palletType?.toLowerCase();
        palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
        condition = condition?.toString()
        condition = condition?.toLowerCase();
        condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

        return size + " " + grade + ", " + palletType + "-" + condition
      } else {
        return palletType + "-" + condition
      }


    }

  }

  return (
    <>
      <TableContainer className='dashboard-table responsive-table'>
        <Table responsive>
          <thead>
            <tr>
              {props?.headerArr.map((items, index) => (
                <th key={index}>{items}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props?.response?.length !== 0 ? props?.response?.map((items, index) => (
              <tr key={index}>
                <td title={items?.refNo}>{items?.refNo}</td>
                <td><div className='location-td'>{items?.location?.city}, {getStateAbbr(items?.location?.state)}</div></td>
                <td className='order-details-style' title={isMixPallet(items) ? 'View Mix Pallet' : `${items?.quantity}, ${orderType(items)}`}>
                  {isMixPallet(items) ? (
                    <button
                      type="button"
                      className="view-mix-pallet-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewMixPallet(items);
                      }}
                    >
                      View Mix Pallet
                    </button>
                  ) : (
                    `${items?.quantity}, ${orderType(items)}`
                  )}
                </td>
                {/* <td>{items?.quantity}</td> */}
                <td>{moment(items?.date * 1000).format(FORMAT)}</td>
                {props?.type === "chart" && <td>{status(items?.status)}</td>}
              </tr>
            )) : <tr>
              <td></td>
              <td></td>
              <td>{locale('noRecordsFound')}</td>
              {/* <td></td> */}
              <td></td>
              {props?.type === "chart" && <td></td>}
            </tr>}

          </tbody>
        </Table>
      </TableContainer>

      <MixPalletDetailsModal
        isOpen={mixModalOpen}
        toggle={() => setMixModalOpen(!mixModalOpen)}
        orderData={selectedMixOrder}
        loggedUserCountry={userCountry}
        onlyBreakdown={true}
      />
    </>
  );
};

export default ReactTable;
